import { Route, Truck, MapPin, Clock, Hexagon, Flame, Car, Box } from 'lucide-react';
import { cn } from '@/lib/utils';

export type MapMode = 'route' | 'vroom' | 'pois' | 'iso' | 'fence' | 'heatmap' | 'replay';

interface MapToolbarProps {
  mode: MapMode;
  onChange: (m: MapMode) => void;
  panelOpen: boolean;
  onTogglePanel: () => void;
  is3D: boolean;
  onToggle3D: () => void;
}

const ITEMS: { key: MapMode; label: string; icon: typeof Route }[] = [
  { key: 'route', label: 'Routes', icon: Route },
  { key: 'vroom', label: 'VROOM', icon: Truck },
  { key: 'pois', label: 'POIs', icon: MapPin },
  { key: 'iso', label: 'Iso', icon: Clock },
  { key: 'fence', label: 'Fences', icon: Hexagon },
  { key: 'heatmap', label: 'Heatmap', icon: Flame },
  { key: 'replay', label: 'Vehicle', icon: Car },
];

export default function MapToolbar({
  mode,
  onChange,
  panelOpen,
  onTogglePanel,
  is3D,
  onToggle3D,
}: MapToolbarProps) {
  return (
    <div className="flex h-full w-[60px] flex-col justify-between border-r bg-card">
      <div className="flex flex-col items-center gap-1 py-2">
        {ITEMS.map((it) => {
          const Icon = it.icon;
          const active = mode === it.key && panelOpen;
          return (
            <button
              key={it.key}
              type="button"
              title={it.label}
              onClick={() => {
                if (mode === it.key && panelOpen) {
                  onTogglePanel();
                } else {
                  onChange(it.key);
                  if (!panelOpen) onTogglePanel();
                }
              }}
              className={cn(
                'flex h-12 w-12 flex-col items-center justify-center gap-0.5 rounded-md text-[10px] font-medium transition-colors',
                active
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-accent',
              )}
            >
              <Icon className="h-4 w-4" />
              <span>{it.label}</span>
            </button>
          );
        })}
      </div>

      <div className="flex flex-col items-center gap-1 pb-2">
        <button
          type="button"
          title={is3D ? 'Switch to 2D' : 'Switch to 3D'}
          onClick={onToggle3D}
          className={cn(
            'flex h-12 w-12 flex-col items-center justify-center gap-0.5 rounded-md text-[10px] font-medium transition-colors',
            is3D
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:bg-accent',
          )}
        >
          <Box className="h-4 w-4" />
          <span>{is3D ? '2D' : '3D'}</span>
        </button>
      </div>
    </div>
  );
}
